import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { IMAGES } from "../lib/funnelData";
import { Reveal } from "./Reveal";
import { LegalLinks } from "./Legal";

export const Footer = () => (
  <footer data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <Reveal>
        <div className="relative overflow-hidden rounded-md bg-emeraldx-deep text-canvas px-6 sm:px-12 py-12 sm:py-16 text-center">
          <div className="absolute inset-0 pattern-contour-light" />
          <div className="overlay-grain" />
          <div className="relative">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif [text-wrap:balance]">Ready to find out what your property is really worth?</h2>
            <span className="rule-gold mx-auto mt-6" />
            <p className="mt-5 text-base text-canvas/75 max-w-xl mx-auto [text-wrap:pretty]">Get your free valuation — or call Jody directly and talk to a person, not a call center.</p>
            <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
              <a href="#funnel" data-testid="final-cta-button" className="inline-flex items-center justify-center rounded-full bg-oak hover:bg-oak-dark text-white px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.15em] transition-colors duration-150 active:scale-[0.96]">
                Get My Free Valuation
              </a>
              <a href="tel:8643142752" data-testid="final-cta-call" className="inline-flex items-center justify-center gap-2 rounded-full border border-canvas/30 px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.15em] hover:bg-canvas/10 transition-colors duration-150 active:scale-[0.96]">
                <Phone size={15} /> (864) 314-2752
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid sm:grid-cols-3 gap-8">
        <div>
          <img src={IMAGES.logoPlaque} alt="Cann Realty LLC" className="h-12 w-auto" data-testid="footer-logo" />
          <p className="mt-4 text-sm text-stone-500 leading-relaxed">Land, farms, and homes across the South Carolina Upstate. 24 years of local knowledge, one name on the door.</p>
          <a href="https://www.facebook.com/CannRealtyLLC/" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-emeraldx-deep hover:text-oak transition-colors duration-150">
            <Facebook size={16} /> Follow us on Facebook
          </a>
        </div>
        <div className="text-sm text-stone-600 space-y-2.5">
          <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-stone-400 mb-3">Contact</div>
          <a href="tel:8643142752" data-testid="footer-phone" className="flex items-center gap-2.5 hover:text-emeraldx-deep transition-colors duration-150"><Phone size={15} /> (864) 314-2752</a>
          <a href="mailto:jody@landmansc.com" data-testid="footer-email" className="flex items-center gap-2.5 hover:text-emeraldx-deep transition-colors duration-150"><Mail size={15} /> jody@landmansc.com</a>
          <div data-testid="footer-address" className="flex items-center gap-2.5"><MapPin size={15} /> 1105 Ella St, Anderson SC 29621</div>
        </div>
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-stone-400 mb-3">Fine print</div>
          <p className="text-xs text-stone-400 leading-relaxed" data-testid="footer-disclaimer">
            Every valuation is prepared personally by Jody Cann after reviewing your property — no automated estimates are given out on this site. Submitting the form authorizes Cann Realty to contact you about your request; text messages are sent only if you opt in on the form. Cann Realty is an Equal Housing Opportunity brokerage, licensed in South Carolina.
          </p>
          <LegalLinks />
        </div>
      </div>
      <div className="border-t border-emeraldx-deep/10 py-5 text-center text-xs text-stone-400">
        © {new Date().getFullYear()} Cann Realty LLC · Anderson, South Carolina
      </div>
    </div>
  </footer>
);
